import BoxPostLogo from '../assets/img/logos/boxpost.png';
import ecologisticLogoBig from '../assets/img/logos/ecologistic-big.png';
import ecologisticLogo from '../assets/img/logos/ecologistic.png';
import JonExpressLogo from '../assets/img/logos/jonexpress.png';
import koderLogo from '../assets/img/logos/koder.svg';
import logistarLogoBig from '../assets/img/logos/logistar-big.png';
import logistarLogo from '../assets/img/logos/logistar.png';
import MyBoxLogo from '../assets/img/logos/mybox.png';
import UPMPostLogo from '../assets/img/logos/upmpost-logo.png';
import UPMPost from '../assets/img/logos/upmpost.png';
import { ClientPost } from '../enums/clients';

export const logos: Record<ClientPost, string> = {
  [ClientPost.Koder]: koderLogo,
  [ClientPost.ELS]: ecologisticLogo,
  [ClientPost.ELSTest]: ecologisticLogo,
  [ClientPost.Logistar]: logistarLogo,
  [ClientPost.MyBox]: MyBoxLogo,
  [ClientPost.BoxPost]: BoxPostLogo,
  [ClientPost.JonExpress]: JonExpressLogo,
  [ClientPost.UPMPost]: UPMPostLogo,
};

export const logosBig: Record<ClientPost, string> = {
  [ClientPost.Koder]: koderLogo,
  [ClientPost.ELS]: ecologisticLogoBig,
  [ClientPost.ELSTest]: ecologisticLogoBig,
  [ClientPost.Logistar]: logistarLogoBig,
  [ClientPost.MyBox]: MyBoxLogo,
  [ClientPost.BoxPost]: BoxPostLogo,
  [ClientPost.JonExpress]: JonExpressLogo,
  [ClientPost.UPMPost]: UPMPost,
};
